import Vue from 'vue';
import Vuex from 'vuex';

import site from '@/store/modules/site';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    site,
  },
});
